import React, { useEffect, useState } from 'react';
import {  useLocation, useNavigate } from 'react-router-dom';
import IconCollection from '../../IconCollection/IconCollection';
import General from './General/General';
import ScoringDialogs from './ScoringDialogs/ScoringDialogs';
import StreamingOverlays from './StreamingOverlays/StreamingOverlays';


const Settings = () => {
  const location = useLocation()
  const pathname = location.pathname
  const navigate = useNavigate();
  const streamingOverlays = window.localStorage.getItem("streamingOverlays");
  localStorage.setItem("player", "");
  const goBack = () => {
    navigate(-1);
  };

  const [settingsTab, setSettingsTab] = useState('');
  const isMobile = window.innerWidth <= 768;
  useEffect(() => {
    if (isMobile) {
      setSettingsTab('')
    } else {
      setSettingsTab('general')
    }
  }, [isMobile])
  const handleClick = (tabName) => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      setSettingsTab((prevTab) => (prevTab === tabName ? '' : tabName));
    } else {
      setSettingsTab(tabName);
    }
  };


  useEffect(() => {
    if (streamingOverlays) {
      setSettingsTab(streamingOverlays)
    }
  }, [streamingOverlays])

  const renderSettingsTab = () => {
    switch (settingsTab) {
      case 'general':
        return <General />;
      case 'scoringDialogs':
        return <ScoringDialogs />;
      case 'streamingOverlays':
        return <StreamingOverlays />;
      default:
        return <General />;
    }
  };


  return (
    <div className='mx-auto w-full'>

      {
        pathname === "/settings" && (

      <div className='max-w-[1512px] w-full mx-auto px-6 md:px-12 h-20 flex justify-start items-center '>


        <button onClick={() => goBack()} className='flex justify-start items-center gap-2  cursor-pointer'>
          <IconCollection customClass='md:max-w-[25px] max-w-[10.16px] w-full md:h-[24px] h-[10.16px]' name="arrow-left" />
          <p className='text-xl font-montserrat font-medium text-[#4A4A4A]'>Settings</p>
        </button>
      </div> )
           }
      <div className='w-full h-[1px] border-b-[1px] border-[#E8E8E8]'></div>
      <div className='flex flex-col md:flex-row mx-auto max-w-[1512px] w-full px-6 md:px-12'>
        <div className={`max-w-full md:max-w-[240px] w-full border-r-0 md:border-r-[1px] h-auto  border-r-[#E8E8E8] min-h-[calc(100vh-100px)]`}>
          <div className='pt-6 flex flex-col gap-2'>

            <button onClick={() => handleClick('general')} className={`px-2 md:px-6 py-2 max-w-full  md:max-w-[216px]  w-full cursor-pointer h-12   ${settingsTab === 'general' ? 'bg-transparent md:bg-primary text-primary md:text-white  hover:bg-transparent md:hover:bg-secondary' : 'hover:bg-slate-200  text-[#4A4A4A]'} text-base font-montserrat rounded flex justify-between md:justify-start items-center font-medium `} >
              General

              <div className='inline-block md:hidden'>
                {settingsTab === 'general' ? <IconCollection name="arrow-up-color" /> : <IconCollection name="arrow-down" />}
              </div>

            </button>


            <div className='inline-block md:hidden'>
              {
                settingsTab == 'general' && <General />
              }

            </div>
            <div className='bg-[#E8E8E8] w-full h-[1px] block md:hidden'></div>
            <button onClick={() => handleClick('scoringDialogs')} className={`px-2 md:px-6 py-2 max-w-full md:max-w-[216px]  w-full cursor-pointer h-12   ${settingsTab === 'scoringDialogs' ? 'bg-transparent md:bg-primary text-primary md:text-white  hover:bg-transparent md:hover:bg-secondary' : 'hover:bg-slate-200  text-[#4A4A4A]'} text-base font-montserrat rounded flex justify-between md:justify-start items-center font-medium `} >
              Scoring Dialogs

              <div className='inline-block md:hidden'>
                {settingsTab === 'scoringDialogs' ? <IconCollection name="arrow-up-color" /> : <IconCollection name="arrow-down" />}
              </div>

            </button>

            <div className='inline-block md:hidden'>
              {
                settingsTab == 'scoringDialogs' && <ScoringDialogs />
              }

            </div>
            <div className='bg-[#E8E8E8] w-full h-[1px] block md:hidden'></div>
            <button onClick={() => handleClick('streamingOverlays')} className={`px-2 md:px-6 py-2 max-w-full md:max-w-[216px]  w-full cursor-pointer h-12   ${settingsTab === 'streamingOverlays' ? 'bg-transparent md:bg-primary text-primary md:text-white  hover:bg-transparent md:hover:bg-secondary' : 'hover:bg-slate-200  text-[#4A4A4A]'} text-base font-montserrat rounded flex justify-between md:justify-start items-center font-medium `} >
              Streaming Overlays
              <div className='inline-block md:hidden'>
                {settingsTab === 'streamingOverlays' ? <IconCollection name="arrow-up-color" /> : <IconCollection name="arrow-down" />}
              </div>
            </button>

            <div className='inline-block md:hidden'>
              {
                settingsTab == 'streamingOverlays' && <StreamingOverlays />
              }

            </div>
            <div className='bg-[#E8E8E8] w-full h-[1px] block md:hidden'></div>
          </div>
        </div>
        <div className='pt-6 w-full pl-6 hidden md:block min-h-[calc(100vh-100px)] pb-5'>
          {renderSettingsTab()}
        </div>
      </div>

    </div>
  );
};

export default Settings;